// extracted by mini-css-extract-plugin
export default {"hidden-switch":"components-Switch-Switch-module__hidden-switch--t0Nf0"};